The type of event to subscribe to.

See `Event` implementations for a list of supported values.
